import React, { useState } from 'react';
import Product from '../models/Product'
import { useFetch, Items } from '@thinkwell/react.common'

const ProductsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const ProductsProvider = (props) => {
  const products = (props && props.value || []).map((c) => Product(c))
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(products))

  const setProducts = (items) => {
    const products = items.map((i) => Product(i))
    setItems(products)
  }
  const [fetchProductsState, fetchProducts] = useFetch({onSuccess: setProducts})

  const upsertProduct = (item) => {
    upsertItem(Product(item))
  }

  const value = [items, fetchProducts, fetchProductsState, upsertProduct, getItem, deleteItem]
  props.onValue && props.onValue(value)

  return (
    <ProductsContext.Provider value={value}>
      {props.children}
    </ProductsContext.Provider>
  );
};

export { ProductsContext, ProductsProvider}
